import { render, staticRenderFns } from "./JuegoVienw.vue?vue&type=template&id=c83eee6a"
import script from "./JuegoVienw.vue?vue&type=script&lang=js"
export * from "./JuegoVienw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports